// extracted by mini-css-extract-plugin
module.exports = {"Experience":"Experience_Experience__mJx_U","fadeIn":"Experience_fadeIn__PX8nh","scaleIn":"Experience_scaleIn___xDYw"};